import { useEffect, useState } from "react";
import { BehaviorSubject } from "rxjs";
import { IDropdownData } from "../_common/interface/dropdown/iDropdownData.interface";

export interface AuctionHeaderOnBehalf {
    catalogueId?: number;
    selected: IDropdownData | null;
    onSelect: (user: IDropdownData | null) => void;
}

export interface AuctionHeaderState {
    dateLabel?: string | null;
    typeLabel?: string | null;
    onBehalf?: AuctionHeaderOnBehalf | null;
}

const subject = new BehaviorSubject<AuctionHeaderState>({});

export const auctionHeaderService = {
    state: subject.asObservable(),
    get value() {
        return subject.value;
    },
    set(next: Partial<AuctionHeaderState>) {
        subject.next({ ...subject.value, ...next });
    },
    reset() {
        subject.next({});
    },
};

export function useAuctionHeader(): AuctionHeaderState {
    const [state, setState] = useState<AuctionHeaderState>(subject.value);
    useEffect(() => {
        const subscription = subject.subscribe(setState);
        return () => subscription.unsubscribe();
    }, []);
    return state;
}
